import communityHttpClient from './httpClient';
import COMMUNITY_ENDPOINTS from './endpoints';

const BASE_URL = COMMUNITY_ENDPOINTS.PROGRESS;

export const getAll = (params = {}) =>
  communityHttpClient.get(`${BASE_URL}/`, { params });

export const toggleBookmark = (postId) =>
  communityHttpClient.post(`${BASE_URL}/toggle_bookmark/`, { post_id: postId });

export const markComplete = (postId) =>
  communityHttpClient.post(`${BASE_URL}/mark_complete/`, { post_id: postId });

export const toggleComplete = (postId, learningPathId = null) =>
  communityHttpClient.post(`${BASE_URL}/toggle_complete/`, {
    post_id: postId,
    learning_path_id: learningPathId
  });

export const getCompletedLessons = (learningPathId) =>
  communityHttpClient.get(`${BASE_URL}/completed_lessons/`, {
    params: { learning_path_id: learningPathId }
  });

export default {
  getAll,
  toggleBookmark,
  markComplete,
  toggleComplete,
  getCompletedLessons
};
